












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VLetterIcon from "@/components/VLetterIcon.vue";

@Component({
  components: {
    VLetterIcon,
  },
})
export default class LogoWithFallback extends Vue {
  @Prop() readonly candidates!: string[];
  @Prop() readonly name!: string;
  @Prop() readonly color!: string;

  private loading = true;
  url: string | null = null;

  @Watch("candidates")
  async onCandidatesChange() {
    await this.loadCandidates();
  }

  async created() {
    await this.loadCandidates();
  }

  async loadCandidates() {
    this.loading = true;
    for (const candidate of this.candidates) {
      try {
        await this.loadImage(candidate);
        this.url = candidate;
        break;
      } catch (e) {
        this.url = null;
      }
    }
    this.loading = false;
  }

  loadImage(url: string) {
    const image = new Image();
    return new Promise((resolve, reject) => {
      image.src = url;
      image.onload = resolve;
      image.onerror = reject;
    });
  }
}
